export const RaceValue = {
  White: 'White',
  Black: 'Black or African American',
  Asian: 'Asian',
  Indian: 'American Indian or Alaska Native',
  NativeHawaiian: 'Native Hawaiian or Other Pacific Islander',
  DECLINED_TO_ANSWER: 'Declined to Answer',
} as const;
